<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.foreman" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td rowspan="2">№ п/п</td>
          <td rowspan="2">Номер сварного соединения по чертежам (исполнительные чертежи)</td>
          <td rowspan="2">Труба Д * S, мм</td>
          <td rowspan="2">Марка стали</td>
          <td rowspan="2">Тип электродов, марка сварной проволоки</td>
          <td rowspan="2">Дата сварки</td>
          <td rowspan="2">Дата термической обработки</td>
          <td rowspan="2">Вид термической обработки</td>
          <td rowspan="2">Способ нагрева</td>
          <td rowspan="2">Метод контроля температуры</td>
          <td rowspan="2">Номер диаграмм или время замера температуры</td>
          <td colspan="4">Термическая обработка</td>
          <td rowspan="2">Фамилия, имя, отчество, клеймо, и подпись термиста-оператора</td>
          <td rowspan="2">Номер протокола замеровтвердости, дата</td>
          <td rowspan="2">Оценка годности сварного соединения после термообработки</td>
          <td rowspan="2">Фамилия, инициалы и подпись руководителя работ по термообработке</td>
          <td rowspan="2"></td>
        </tr>
        <tr class="header">
          <td>Температура нагрева, С</td>
          <td>Скорость нагрева, С/ч</td>
          <td>Время выдержки, ч</td>
          <td>Характер охлаждения</td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td>11</td>
          <td>12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td></td>
        </tr>
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.date) }}
      </template>
      <template #termSign="{item}">
        <c-journal-sign :sign="getSign(item, 'term')" />
      </template>
      <template #foremanSign="{item}">
        <c-journal-sign :sign="getSign(item, 'foreman')" />
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from 'components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { CJournalSign, ModalRecord, PageRecordCreate, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        foreman: $app.auth.can('journals_'+this.journal.name+'_foreman', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'number', title: '', },
        { name: 'numberWelding', title: '', },
        { name: 'pipe', title: '', },
        { name: 'steelMark', title: '', },
        { name: 'electrodType', title: '', },
        { name: 'weldingDate', title: '', },
        { name: 'termingDate', title: '', },
        { name: 'termingType', title: '', },
        { name: 'heatingWay', title: '', },
        { name: 'tempControlMethod', title: '', },
        { name: 'diagramNum', title: '', },
        { name: 'heatingTemp', title: '', },
        { name: 'heatingTime', title: '', },
        { name: 'heatingSpeed', title: '', },
        { name: 'coolingChar', title: '', },
        { name: 'termSign', title: '', },
        { name: 'protocolNum', title: '', },
        { name: 'weldingGrade', title: '', },
        { name: 'foremanSign', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load() 
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name)
        .query({
          'with[records][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
